//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
//Add
import axios from 'axios';
import config from '../config';


//Part
import PartPageTitle from './PartPageTitle';



class Comp extends React.Component {

  constructor(props) {
    super(props);
  	this.state = {
      list: [],
      keyword: '',
  	}
  }

  componentDidMount() {
    document.title = 'ヘルプ - パートナーズ';
    const params = new URLSearchParams();
    params.append('type', 'index');
    return axios.post(config.apiUri + "helpApi.php", params, {
      timeout: 10000,
    })
    .then((res) => {
      this.setState({list: res.data.list});
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }


	_renderList = (value, index) => {
		return (
      <div key={index} style={{width:'50%'}}>
        <div style={{margin:'5px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category', value.help_category_name_en) }
            fullWidth
          >
      			 {value.help_category_name}
          </Button>
        </div>
      </div>
		);
	};



	render() {
		return (
      <div>
        <PartPageTitle
          title={'ヘルプ'}
          onback={ '/' }
        />

        <div style={{maxWidth:'600px', margin:'auto'}}>

          <div style={{padding:'10px'}}>

            <div style={{fontSize:'0.9em', color:'#666'}}>単語をスペースで区切って入力してください</div>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                textAlign:'center',
                alignItems:'center',
                justifyContent:'space-between',
              }}
            >

              <input
                style={{fontSize:'1.2em'}}
                className="input_blue round12"
                value={this.state.keyword}
                placeholder="例) 写真 削除"
                maxLength={20}
                onChange={(e) => this.setState({keyword: e.target.value})}
              />

              <div style={{width:'100px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ () => this.props.helpOpen('keyword', this.state.keyword) }

                >
                  <span style={{fontSize:'1.2em'}}>検索</span>
                </Button>
              </div>
            </div>
          </div>
          <div
            style={{
              display:'flex',
              flexWrap:'wrap',
            }}
          >
          {
  					this.state.list.map(
            	(value, index) => this._renderList(value, index)
          	)
  				}
          </div>
      	</div>
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {

	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
